import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet #outlet="outlet" />`,
  styleUrl: './app.component.scss',
})
export class AppComponent {}
